import { find, map } from 'lodash';
import moment from 'moment';

class AvailabilityFormController {
    constructor($scope, $state, availabilityModelService, messageService) {
        this.$scope = $scope;
        this.$state = $state;
        this.availabilityModelService = availabilityModelService;
        this.messageService = messageService;
    }

    $onInit () {
        this.availability = this.availability || {};
        this.availability.start = (this.availability.start) ? moment(this.availability.start, 'YYYY-MM-DD HH:mm:ss') : '';
        this.availability.end = (this.availability.end) ? moment(this.availability.end, 'YYYY-MM-DD HH:mm:ss') : '';
        this.availability.type = this.availability.exclusion_type || this.availability.inclusion_type || '';

        this.availability.event = this.availability[this.type];

        if (this.availability.exclusion_id || this.availability.inclusion_id && this.determineList()) {
            this.availability.event = find(this.determineList(), { id: this.availability.exclusion_id || this.availability.inclusion_id });
        }
    }

    onSave () {
        if (this.availability.start) {
            this.availability.start = this.availability.start.format('YYYY-MM-DD HH:mm:00');
        }

        if (this.availability.end) {
            this.availability.end = this.availability.end.format('YYYY-MM-DD HH:mm:00');
        }

        if (!this.availability.type) {
            this.availability[`${this.type}_type`] = undefined;
        } else {
            this.availability[`${this.type}_type`] = this.availability.type;
        }

        if (this.availability.event) {
            switch (this.availability.type) {
                case 'App\\Treatment':
                case 'App\\SpaDay':
                case 'App\\EventCategory':
                    this.assignItem();
                    break;
            }
        }

        if (this.availability.days) {
            this.availability.days = map(this.availability.days, 'day');
        }

        this.availability.type = undefined;
        this.availability.event = undefined;

        return this.availabilityModelService.save(this.availability, this.type)
            .then(response => {
                if (this.availability.id) {
                    this.messageService.success(`The availability rule was successfully updated!`, [`app.admin.availability-edit({ 'availability' : ${this.availability.id}, 'type': '${this.type}'})`, `Rule`]);
                    this.$state.go('app.admin.availability');
                } else {
                    this.messageService.success(`The availability rule was successfully created.`, [`app.admin.availability-edit({ 'availability' : ${response.id}, 'type': '${this.type}'})`, `Rule`]);
                    this.$state.go('app.admin.availability');
                }
            })
            .catch((error) => {
                let sourceElement = Object.keys(error.data);
                let verb = 'created';
                if (this.availability.id) {
                    verb = 'updated';
                }
                if (sourceElement.length > 0) {
                    let errors = '';
                    for (let element of sourceElement) {
                        errors += `<li>${this.messageService.formatError(element, error.data[element])}</li>`;
                    }
                    this.messageService.failure(`The availability rule could not be successfully ${verb}: <ul>${errors}</ul>`);
                } else {
                    this.messageService.failure(`The availability rule could not be successfully ${verb}: ${error.statusText}`);
                }
                this.messageService.push();
            });
    }

    assignItem () {
        this.availability[`${this.type}_type`] = this.availability.event.type_raw;
        this.availability[`${this.type}_id`] = this.availability.event.id;
    }

    selector () {
        switch (this.availability.type) {
            case 'App\\EventCategory':
            case 'App\\SpaDay':
            case 'App\\Treatment':
                return true;
        }
    }

    setTime (time) {
        switch (time) {
            case 0:
                if (this.availability.start) {
                    this.availability.start.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
                }
                break;

            case 1:
                if (this.availability.end) {
                    this.availability.end.set({ hour: 23, minute: 59, second: 59, millisecond: 59 });
                }
                break;
        }
    }

    determineList () {
        switch (this.availability.type) {
            case 'App\\EventCategory':
                return this.categories;
            case 'App\\SpaDay':
                return this.events.SpaDay;
            case 'App\\Treatment':
                return this.events.Treatment;
        }
    }

}

AvailabilityFormController.$inject = ['$scope', '$state', 'availabilityModelService', 'messageService'];

export default AvailabilityFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/controllers/availability.form.controller.js